export const MAIL_API_KEY = 'api-3FFC7C0AD4E54AE7BA6C0D5C23CA3AC9';
export const MAIL_SENDER = 'Sleipner <noreply@meiko.fi>';
export const LEAD_MAIL = 'sleipner@sleipner.com';
export const LOGO_FILENAME = 'logo.jpg';
